import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { ProdData } from '../_models/prod_data';
import { Departure } from '../_models/departure';
import { Inventory } from '../_models/inventory_loc';
import { Globals } from '../_globals/globals';
import {Zone} from '../_models/zone';
import { OptiData } from '../_models/opti_data';
import { OptiPiece } from '../_models/opti_piece';


@Injectable({
  providedIn: 'root'
})

export class OptiService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

    // ----------- COMPACTAR OPTIMIZACIONES  -----------
  
  compactOpti(searchParams): Observable<OptiData[]> {

    console.log('-->--> Ejecutando servicio compactOpti');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };
    return this.http.get<OptiData[]>(this.globals.apiUrl + '/compact_opti', options)
      .pipe(
        tap( data => console.log(' -> Optimizaciones obtenidas desde compactOpti: ')), // + JSON.stringify(data))),
        catchError(this.handleError<OptiData[]>('compactOpti', [])
      ));
  } // End function compactOpti
  
  // ----------- OPTIMIZACIONES  -----------
  
  getAllOpti(searchParams): Observable<OptiData[]> {

    console.log('-->--> Ejecutando servicio getAllOpti');
    console.log(searchParams);
    console.log('---------------');

    // NOTA: Transformación para poder buscar el caracter "+" dentro del campo.
    if (searchParams['filterField_3'] !== null && searchParams['filterField_3'] !== undefined) {
      searchParams['filterField_3'] = searchParams['filterField_3'].replace('+', '&#43;')
    }

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };
    return this.http.get<OptiData[]>(this.globals.apiUrl + '/optis', options)
      .pipe(
        tap( data => console.log(' -> Optimizaciones obtenidas desde getAllOpti: ')), // + JSON.stringify(data))),
        catchError(this.handleError<OptiData[]>('getAllOpti', [])
      ));
  } // End function getAllOpti

  getFloorOptimizationMatches(pairsIn: any[]): Observable<any> {

    console.log('-->--> Ejecutando servicio getFloorOptimizationMatches');
    console.log(pairsIn);
    console.log('---------------');

    return this.http.post<any>(
      this.globals.apiUrl + '/opti_floor_matches',
      { pairs: Array.isArray(pairsIn) ? pairsIn : [] }
    ).pipe(
      timeout(120000),
      tap(data => console.log(' -> Coincidencias lote/material de VS-Floor obtenidas.')),
      catchError(this.handleError<any>('getFloorOptimizationMatches', null))
    );
  } // End function getFloorOptimizationMatches
  
  getRetalOpti(searchParams): Observable<OptiPiece[]> {

    console.log('-->--> Ejecutando servicio getRetalOpti');
    console.log(searchParams);
    console.log('---------------');

    // NOTA: Transformación para poder buscar el caracter "+" dentro del campo.
    if (searchParams['filterField_3'] !== null && searchParams['filterField_3'] !== undefined) {
      searchParams['filterField_3'] = searchParams['filterField_3'].replace('+', '&#43;')
    }

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };
    return this.http.get<OptiPiece[]>(this.globals.apiUrl + '/opti_retals', options)
      .pipe(
        tap( data => console.log(' -> Retales obtenidos desde getRetalOpti: ')), // + JSON.stringify(data))),
        catchError(this.handleError<OptiPiece[]>('getRetalOpti', [])
      ));
  } // End function getRetalOpti
  
  // Guardar la información de piezas obtenidas en una optimización.
  saveOptiPiece(optiPieceIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio saveOptiPiece');
    console.log(optiPieceIn);
    console.log('---------------');

    let options = {};

    return this.http.post<any>(this.globals.apiUrl + '/opti_piece', optiPieceIn, options)
      .pipe(
        tap( data => console.log('save opti_piece')),
        catchError(this.handleError<any>('saveOptiPiece', null)
      ));
  } // End function saveOptiPiece
  
  chargeOpti(searchParams): Observable<OptiPiece[]> {

    console.log('-->--> Ejecutando servicio chargeOpti');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };
    return this.http.get<OptiPiece[]>(this.globals.apiUrl + '/charge_opti', options)
      .pipe(
        tap( data => console.log(' -> Piezas para cargar obtenidas desde chargeOpti: ')), // + JSON.stringify(data))),
        catchError(this.handleError<OptiPiece[]>('chargeOpti', [])
      ));
  } // End function chargeOpti

  startOptimizerBenchmark(payloadIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio startOptimizerBenchmark');
    console.log(payloadIn);
    console.log('---------------');

    return this.http.post<any>(this.globals.apiUrl + '/optimizer_benchmark', payloadIn ? payloadIn : {})
      .pipe(
        timeout(120000),
        tap( data => console.log(' -> Benchmark optimizador iniciado: ')),
        catchError(this.handleError<any>('startOptimizerBenchmark', null)
      ));
  } // End function startOptimizerBenchmark

  getOptimizerBenchmark(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio getOptimizerBenchmark');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }
    params = params.set('_ts', Date.now().toString());

    const options = { params: params };
    const includeFullSnapshot = searchParams &&
      (searchParams.full === true || searchParams.full === 'true');
    const responseTimeoutMs = includeFullSnapshot ? 600000 : 120000;
    return this.http.get<any>(this.globals.apiUrl + '/optimizer_benchmark', options)
      .pipe(
        timeout(responseTimeoutMs),
        tap( data => console.log(' -> Benchmark optimizador consultado: ')),
        catchError(this.handleError<any>('getOptimizerBenchmark', null)
      ));
  } // End function getOptimizerBenchmark

  getOptimizerBenchmarkQueue(): Observable<any> {

    const options = { params: new HttpParams().set('_ts', Date.now().toString()) };
    return this.http.get<any>(this.globals.apiUrl + '/optimizer_benchmark', options)
      .pipe(
        timeout(120000),
        catchError(this.handleError<any>('getOptimizerBenchmarkQueue', null)
      ));
  } // End function getOptimizerBenchmarkQueue

  cancelOptimizerBenchmark(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio cancelOptimizerBenchmark');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };
    return this.http.delete<any>(this.globals.apiUrl + '/optimizer_benchmark', options)
      .pipe(
        tap( data => console.log(' -> Benchmark optimizador cancelado: ')),
        catchError(this.handleError<any>('cancelOptimizerBenchmark', null)
      ));
  } // End function cancelOptimizerBenchmark

  clearOptimizerBenchmarkQueue(scopeIn: string = 'finished'): Observable<any> {

    console.log('-->--> Ejecutando servicio clearOptimizerBenchmarkQueue');
    console.log(scopeIn);
    console.log('---------------');

    const options = { params: new HttpParams().set('scope', scopeIn || 'finished') };
    return this.http.delete<any>(this.globals.apiUrl + '/optimizer_benchmark', options)
      .pipe(
        tap( data => console.log(' -> Cola benchmark optimizador limpiada: ')),
        catchError(this.handleError<any>('clearOptimizerBenchmarkQueue', null)
      ));
  } // End function clearOptimizerBenchmarkQueue

  private buildParams(searchParams: any): HttpParams {
    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key) && searchParams[key] !== null && searchParams[key] !== undefined && searchParams[key] !== '') {
          params = params.set(key, searchParams[key]);
        }
      }
    }
    return params;
  }

  getProductionPlanningBatches(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio getProductionPlanningBatches');
    console.log(searchParams);
    console.log('---------------');

    return this.http.get<any>(this.globals.apiUrl + '/production_planning_batches', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Lotes de producción obtenidos: ')),
        catchError(this.handleError<any>('getProductionPlanningBatches', {data: [], count: 0})
      ));
  } // End function getProductionPlanningBatches

  getProductionPlanningBatch(searchParams: any): Observable<any[]> {

    console.log('-->--> Ejecutando servicio getProductionPlanningBatch');
    console.log(searchParams);
    console.log('---------------');

    return this.http.get<any[]>(this.globals.apiUrl + '/production_planning_batch', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Detalle de lote de producción obtenido: ')),
        catchError(this.handleError<any[]>('getProductionPlanningBatch', [])
      ));
  } // End function getProductionPlanningBatch

  getProductionPlanningBatchAudit(searchParams: any): Observable<any[]> {

    console.log('-->--> Ejecutando servicio getProductionPlanningBatchAudit');
    console.log(searchParams);
    console.log('---------------');

    return this.http.get<any[]>(this.globals.apiUrl + '/production_planning_batch_audit', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Audit trail de lote obtenido: ')),
        catchError(this.handleError<any[]>('getProductionPlanningBatchAudit', [])
      ));
  } // End function getProductionPlanningBatchAudit

  getProductionPlanningBatchStatus(searchParams: any): Observable<any[]> {

    console.log('-->--> Ejecutando servicio getProductionPlanningBatchStatus');
    console.log(searchParams);
    console.log('---------------');

    return this.http.get<any[]>(this.globals.apiUrl + '/production_planning_batch_status', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Estado de pasos de lote obtenido: ')),
        catchError(this.handleError<any[]>('getProductionPlanningBatchStatus', [])
      ));
  } // End function getProductionPlanningBatchStatus

  getProductionPlanningPending(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio getProductionPlanningPending');
    console.log(searchParams);
    console.log('---------------');

    return this.http.get<any>(this.globals.apiUrl + '/production_planning_pending', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Pedidos pendientes de planificación obtenidos: ')),
        catchError(this.handleError<any>('getProductionPlanningPending', {data: [], product_types: [], load_error: true})
      ));
  } // End function getProductionPlanningPending

  getProductionPlanningPendingPositions(searchParams: any): Observable<any[]> {

    console.log('-->--> Ejecutando servicio getProductionPlanningPendingPositions');
    console.log(searchParams);
    console.log('---------------');

    return this.http.get<any[]>(this.globals.apiUrl + '/production_planning_pending_positions', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Posiciones pendientes de planificación obtenidas: ')),
        catchError(this.handleError<any[]>('getProductionPlanningPendingPositions', [])
      ));
  } // End function getProductionPlanningPendingPositions

  getProductionPlanningNextBatch(searchParams: any = {}): Observable<any> {

    console.log('-->--> Ejecutando servicio getProductionPlanningNextBatch');

    return this.http.get<any>(this.globals.apiUrl + '/production_planning_next_batch', { params: this.buildParams(searchParams || {}) })
      .pipe(
        tap( data => console.log(' -> Siguiente lote de producción obtenido: ')),
        catchError(this.handleError<any>('getProductionPlanningNextBatch', null)
      ));
  } // End function getProductionPlanningNextBatch

  createProductionPlanningBatch(payloadIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio createProductionPlanningBatch');
    console.log(payloadIn);
    console.log('---------------');

    return this.http.post<any>(this.globals.apiUrl + '/production_planning_batch', payloadIn || {}, {})
      .pipe(
        tap( data => console.log(' -> Lote de producción creado: ')),
        catchError(this.handlePlanningMutationError('createProductionPlanningBatch')
      ));
  } // End function createProductionPlanningBatch

  previewProductionPlanningBatch(payloadIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio previewProductionPlanningBatch');

    return this.http.post<any>(this.globals.apiUrl + '/production_planning_batch_preview', payloadIn || {}, {})
      .pipe(
        tap(data => console.log(' -> Vista temporal del lote preparada para impresión: ')),
        catchError(this.handlePlanningMutationError('previewProductionPlanningBatch')
      ));
  } // End function previewProductionPlanningBatch

  deleteProductionPlanningBatch(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio deleteProductionPlanningBatch');
    console.log(searchParams);
    console.log('---------------');

    return this.http.delete<any>(this.globals.apiUrl + '/production_planning_batch', { params: this.buildParams(searchParams) })
      .pipe(
        tap( data => console.log(' -> Lote de producción eliminado: ')),
        catchError(this.handlePlanningMutationError('deleteProductionPlanningBatch')
      ));
  } // End function deleteProductionPlanningBatch
  
  deleteOpti(optiIn: OptiData): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteOpti');
    console.log(optiIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', optiIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/opti_data', options)
      .pipe(
        tap(  _ => console.log('deleted opti')),
        catchError(this.handleError<bigint>('deleteOpti', null)
      ));
  } // End function deleteOpti

  // ----------- PROD-DATA --------------
  getAllProdDatas(searchParams): Observable<ProdData[]> {

    console.log('-->--> Ejecutando servicio getAllProdDatas');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('finished', searchParams.finished)
        .set('searchDesc', searchParams.searchDesc)
        .set('searchName', searchParams.searchName)
    };
    return this.http.get<ProdData[]>(this.globals.apiUrl + '/prod_datas', options)
      .pipe(
        tap( data => console.log(' -> ProdDatas obtenidos desde getAllProdDatas: ')), // + JSON.stringify(data))),
        catchError(this.handleError<ProdData[]>('getAllProdDatas', [])
      ));
  }

  getAllInventories(searchParams): Observable<Inventory[]> {

    console.log('-->--> Ejecutando servicio getAllInventories');
    console.log(searchParams);
    console.log('---------------');

    // NOTA: Transformación para poder buscar el caracter "+" dentro del campo.
    if (searchParams['filterField_3'] !== null && searchParams['filterField_3'] !== undefined) {
      searchParams['filterField_3'] = searchParams['filterField_3'].replace('+', '&#43;')
    }

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };
    return this.http.get<Inventory[]>(this.globals.apiUrl + '/inventories', options)
      .pipe(
        tap( data => console.log(' -> ProdDatas obtenidos desde getAllInventories: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Inventory[]>('getAllInventories', [])
      ));
  }
  
  // ----------------------------------
  // 	ESTUDIO DE PRODUCTIVIDAD
  // ----------------------------------
  // Realizar el estudio de productividad de un lote.
  lotStudy(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio lotStudy.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<any[]>(this.globals.apiUrl + '/lot_study', options)
      .pipe(
        tap( data => console.log(' -> Datos obtenidos desde lotStudy: ')), // + JSON.stringify(data))),
        catchError(this.handleError<any[]>('lotStudy', [])
      ));
  } // End function lotStudy

  lotRelations(searchParams: any): Observable<any> {
    console.log('-->--> Ejecutando servicio lotRelations.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };
    return this.http.get<any>(this.globals.apiUrl + '/lot_relations', options)
      .pipe(
        tap( data => console.log(' -> Datos obtenidos desde lotRelations: ')),
        catchError(this.handleError<any>('lotRelations', { rows: [] }))
      );
  } // End function lotRelations
  
  // Guardar la información de piezas obtenidas en una optimización.
  divideLot(progressIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio divideLot');
    console.log(progressIn);
    console.log('---------------');

    let options = {};

    return this.http.post<any>(this.globals.apiUrl + '/divide_lot', progressIn, options)
      .pipe(
        tap( data => console.log('divide lot')),
        catchError(this.handleError<any>('divideLot', null)
      ));
  } // End function divideLot
  /*
  divideLot(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio divideLot.');
    console.log(searchParams);
    console.log('---------------');

    let options = {};

    return this.http.get<any[]>(this.globals.apiUrl + '/divide_lot', options)
      .pipe(
        tap( data => console.log(' -> Datos obtenidos desde divideLot: ')), // + JSON.stringify(data))),
        catchError(this.handleError<any[]>('divideLot', [])
      ));
  } // End function divideLot // */

  // ------- Servicios para carga de listados en selectores ------

  getSizes(searchParams): Observable<any> {

    console.log('-->--> Ejecutando servicio getSizes');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };

    return this.http.get<any>(this.globals.apiUrl + '/sizes', options)
      .pipe(
        tap( data => console.log(' -> Medidas obtenidas desde getSizes: ')), // + JSON.stringify(data))),
        catchError(this.handleError<any>('getSizes', [])
        ));
  }

  getNameZones(searchParams): Observable<string[]> {

    console.log('-->--> Ejecutando servicio getNameZones');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };

    // console.log('--> -- Options = ');
    // console.log(options);

    return this.http.get<string[]>(this.globals.apiUrl + '/name_zones', options)
      .pipe(
        tap( data => console.log(' -> Nombre de zonas obtenidas desde getNameZones: ')), // + JSON.stringify(data))),
        catchError(this.handleError<string[]>('getNameZones', [])
        ));
  }

  getZones(searchParams): Observable<Zone[]> {

    console.log('-->--> Ejecutando servicio OptigetZones');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };

    // console.log('--> -- Options = ');
    // console.log(options);

    return this.http.get<Zone[]>(this.globals.apiUrl + '/remnant_zones', options)
      .pipe(
        tap( data => console.log(' -> Zonas obtenidas desde OptigetZones: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Zone[]>('getZones', [])
        ));
  }

  getDistinctLagers(searchParams): Observable<Departure[]> {

    console.log('-->--> Ejecutando servicio getDistinctLagers');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Departure[]>(this.globals.apiUrl + '/lagers_dist', options)
      .pipe(
        tap( data => console.log(' -> ProdDatas obtenidos desde getDistinctLagers: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Departure[]>('getDistinctLagers', [])
      ));
  }

  getDistinctLocations(searchParams): Observable<Inventory[]> {

    console.log('-->--> Ejecutando servicio getDistinctLocations');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Inventory[]>(this.globals.apiUrl + '/locations_dist', options)
      .pipe(
        tap( data => console.log(' -> ProdDatas obtenidos desde getDistinctLocations: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Inventory[]>('getDistinctLocations', [])
      ));
  }

  getGroupLocations(searchParams): Observable<Inventory[]> {

    console.log('-->--> Ejecutando servicio getGroupLocations');
    console.log(searchParams);
    console.log('---------------');

    let options = {};

    if (searchParams.filterLagerName != null) {
    // Add safe, URL encoded search parameter if there is a search term
        options = { params: new HttpParams()
        .set('filterLagerName', searchParams.filterLagerName)
        .set('filterLagerMat', searchParams.filterLagerMat)
        .set('filterLagerWidth', searchParams.filterLagerWidth)
        .set('filterLagerHeight', searchParams.filterLagerHeight)
      };
    }
    return this.http.get<Inventory[]>(this.globals.apiUrl + '/locations_group', options)
      .pipe(
        tap( data => console.log(' -> ProdDatas obtenidos desde getGroupLocations: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Inventory[]>('getGroupLocations', [])
      ));
  }
  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

  private handlePlanningMutationError(operationIn: string) {
    return (error: any): Observable<any> => {
      console.error(error);
      const payload = error && error.error ? error.error : null;
      const message = payload && payload.msg
        ? payload.msg
        : (error && error.message ? error.message : 'No se ha podido completar la operación.');
      return of({
        ok: false,
        msg: message,
        operation: operationIn
      });
    };
  }

}
